export default __webpack_public_path__ + "static/media/SVG-Logo-Maker.1dac4318.png";